"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _EventTracker2 = _interopRequireDefault(require("./EventTracker"));

var _configOptions = require("../constants/config-options");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var POLLING_INTERVAL = 500; // ms

var PageEventTracker = /*#__PURE__*/function (_EventTracker) {
  _inherits(PageEventTracker, _EventTracker);

  var _super = _createSuper(PageEventTracker);

  function PageEventTracker() {
    _classCallCheck(this, PageEventTracker);

    return _super.apply(this, arguments);
  }

  _createClass(PageEventTracker, [{
    key: "start",
    value:
    /**
     * Start tracking page events.
     */
    function start() {
      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.TRACK_PAGES_BY_HASH_CHANGE]) {
        this.initializeHashChangeListener();
      } else {
        this.initializeLocationPolling();
      }

      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.TRACK_PAGE_VIEW]) {
        this.eventService.sendPageViewedEvent(window.document.title, window.location.href, this.contextExtensions, this.resultExtensions);
      }
    }
    /**
     * Stop tracking page events.
     */

  }, {
    key: "stop",
    value: function stop() {
      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.TRACK_PAGES_BY_HASH_CHANGE]) {
        window.removeEventListener('hashchange', this.hashChangeHandler);
      } else {
        window.clearInterval(this.poll);
      }

      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.TRACK_PAGE_CLOSE]) {
        if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.STASH_FINAL_PAGE_CLOSE_EVENT]) {
          this.eventService.stashPageClosedEvent(window.location.href, this.contextExtensions, this.resultExtensions);
        } else {
          this.eventService.sendPageClosedEvent(window.location.href, this.contextExtensions, this.resultExtensions);
        }
      }
    }
    /**
     * Send opened and closed events when a new page is loaded.
     *
     * @param {String} newPageName The name of the new/current page.
     * @param {String} newUrl The URL of the new/current page.
     * @param {String} oldUrl The URL of the old/previous page.
     */

  }, {
    key: "sendEvents",
    value: function sendEvents(newPageName, newUrl, oldUrl) {
      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.TRACK_PAGE_VIEW]) {
        this.eventService.sendPageViewedEvent(newPageName, newUrl, this.contextExtensions, this.resultExtensions);
      }

      if (this.trackingConfig[_configOptions.TRACKING_OPTIONS.TRACK_PAGE_CLOSE]) {
        this.eventService.sendPageClosedEvent(oldUrl, this.contextExtensions, this.resultExtensions);
      }
    }
    /**
     * If tracking pages via hashchange, start listening for these events.
     */

  }, {
    key: "initializeHashChangeListener",
    value: function initializeHashChangeListener() {
      var _this = this;

      this.hashChangeHandler = function (hashChangeEvent) {
        return _this.sendEvents(hashChangeEvent.target.ownerDocument.title, hashChangeEvent.newURL, hashChangeEvent.oldURL);
      };

      window.addEventListener('hashchange', this.hashChangeHandler);
    }
    /**
     * If tracking pages via polling, start polling interval.
     */

  }, {
    key: "initializeLocationPolling",
    value: function initializeLocationPolling() {
      var _this2 = this;

      this.currentUrl = window.location.href;
      this.poll = window.setInterval(function () {
        if (_this2.currentUrl !== window.location.href) {
          _this2.sendEvents(window.document.title, window.location.href, _this2.currentUrl);

          _this2.currentUrl = window.location.href;
        }
      }, POLLING_INTERVAL);
    }
  }]);

  return PageEventTracker;
}(_EventTracker2["default"]);

var _default = PageEventTracker;
exports["default"] = _default;
module.exports = exports.default;